// ESLint Settings
/* eslint no-unused-labels: "off", complexity: "off" */
/* globals platformCheck: true, site: true, TimelineMax: true, TweenMax: true, YT: true, Draggable: true, hashHelper: true, Spinner: true, elementScrollProgress: true, Power0: true, Power4: true */

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleHoliday2018V1 = {
    /* eslint-disable no-unused-vars */
    attach: function (context, settings) {
    /* eslint-enable no-unused-vars */
      // DOM
      var $window = $(window);
      var $body = $('body');
      var $boutique = $('#holiday-2018_container', context);
      var $sections = $boutique.find('section');
      // LOGIC
      var platformVars = platformCheck({
        target: $boutique[0],
        mobileSize: 767,
        mobileClass: 'js-mobile',
        desktopClass: 'js-desktop',
        ipadClass: 'js-ipad',
        ieClass: 'js-ie',
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });
      var videoVars = {
        youtubeAPIReady: false,
        scrubberUpdateTimer: undefined,
        volumeSlider: undefined,
        volumeControlFadeout: undefined,
        player: undefined
      };

      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// BEGIN: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // BEGIN: Init
        init: {
          // Init el product
          $boutique.elproduct({
            target: '[data-product]',
            debug: false,
            map: {
              'INVENTORY_STATUS': [
                {
                  selector: '.el-product_shop-now',
                  targets: ['html'],
                  modifier: function (inventoryStatus) {
                    var inventoryStatusLookup = {
                      3: 'Preorder',
                      5: 'Sold Out',
                      7: 'Sold Out'
                    };

                    return inventoryStatusLookup[inventoryStatus];
                  }
                },
                {
                  selector: '[data-product], .el-product_shop-now',
                  targets: ['data-available'],
                  modifier: function (inventoryStatus) {
                    if (inventoryStatus === 3 || inventoryStatus === 7) {
                      return 'false';
                    }

                    return 'true';
                  }
                }
              ]
            },
            onSuccess: function () {
              $('[data-product], .el-product_shop-now').on('click', function (e) {
                // DOM
                var $this = $(this);
                // LOGIC
                var productData = $this.data('productData');

                if ($this.hasClass('quickshop')) {
                  e.preventDefault();

                  // Item must be available for purchase
                  if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
                    return;
                  }

                  site.quickshop(productData);
                } else if ($this.hasClass('add-to-bag')) {
                  e.preventDefault();

                  // Item must be available for purchase
                  if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
                    return;
                  }

                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: productData.defaultSku.SKU_ID.substr(3),
                      PARENT_CAT_ID: productData.PRODUCT_ID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                }
              });
            }
          });
        }
        // END: Init

        // BEGIN: Events
        events: {
          // Detects mobile/desktop dimensions on resize, and handles switches
          $window
            .on('platformcheck-update', function (e) {
              // LOGIC
              var flag = e.originalEvent.detail.flag;

              // Desktop mobile width detection
              if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
                if ($boutique.hasClass('js-mobile')) {
                  $boutique.removeClass('js-mobile');
                  $window.trigger('desktopLostMobile');
                } else {
                  $boutique.addClass('js-mobile');
                  $window.trigger('desktopGainedMobile');
                }
              }

              if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
                if (platformVars.orientation) {
                  $boutique.addClass('js-ipad-portrait');
                } else if (platformVars.orientation === false) {
                  $boutique.removeClass('js-ipad-portrait');
                }

                $window.trigger('orientationChanged');
              }
            });

          // Hide title on mouse enter to prevent tooltips
          // Unhide on mouse leave
          $('a')
            .on('mouseenter', function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var title = $this.attr('title');

              $this.data('title', title);
              $this.removeAttr('title');
            })
            .on('mouseleave', function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var title = $this.data('title');

              if (typeof title !== 'undefined') {
                $this.attr('title', title);
              }
            });
        }
        // END: Events

        // ////////////////////////////////////////////////////////////////////////////////////
        // //////////// BEGIN: Video Modal Handling
        // ////////////////////////////////////////////////////////////////////////////////////
        (function () {
          // DOM
          var $videoModal = $boutique.find('.video_container');
          var $volumeKnob = $videoModal.find('.volume-slider .circle');
          var $volumeButton = $videoModal.find('.volume_btn');
          // LOGIC
          var volumeControlFadeout;
          var volumeSlider;
          var videoVars = {
            youtubeAPIReady: false,
            scrubberUpdateTimer: undefined,
            volumeSlider: undefined,
            volumeControlFadeout: undefined,
            player: undefined
          };

          /**
          * @function youtubeUpdateHandler
          * @description Updates the scrubber as the youtube video progresses
          * @returns {undefined}
          */
          function youtubeUpdateHandler() {
            var duration;
            var currentTime;
            var progress;

            if (typeof videoVars.player === 'undefined' || typeof videoVars.player.getDuration !== 'function') {
              return;
            }

            duration = videoVars.player.getDuration();
            currentTime = videoVars.player.getCurrentTime();
            progress = currentTime / duration;

            $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
          }

          /**
          * @function hideVolumeSlider
          * @description Hides the volume slider
          * @returns {undefined}
          */
          function hideVolumeSlider() {
            if (volumeControlFadeout !== 'undefined') {
              clearTimeout(volumeControlFadeout);
            }

            volumeControlFadeout = setTimeout(function () {
              TweenMax.to($videoModal.find('.volume_btn .volume-slider'), 0.5, {
opacity: 0,
display: 'none',
clearProps: 'all',
onComplete: function () {
                $videoModal.find('.volume_btn').removeClass('js-active');
              }
});

              if (typeof volumeControlFadeout !== 'undefined') {
                clearTimeout(volumeControlFadeout);
              }

              volumeControlFadeout = undefined;
            }, 5000);
          }

          /**
          * @function updateVolumeIcon
          * @description Update the volume icon
          * @param {number} volume Volume value between 0 to 100
          * @returns {undefined}
          */
          function updateVolumeIcon(volume) {
            // Reset
            $volumeButton.removeClass('js-vol-0 js-vol-1 js-vol-2 js-vol-3');

            if (volume === 0) {
              $volumeButton.addClass('js-vol-0');
            } else if (volume <= 33) {
              $volumeButton.addClass('js-vol-1');
            } else if (volume <= 66) {
              $volumeButton.addClass('js-vol-2');
            } else if (volume > 66) {
              $volumeButton.addClass('js-vol-3');
            }
          }

          // BEGIN: Init
          init: {
            volumeSlider = Draggable.create($volumeKnob, {
              bounds: $volumeKnob.parent(),
              type: 'top',
              onDrag: function () {
                // LOGIC
                var progress = 1 - Math.abs(this.y / this.maxY);

                if (typeof videoVars.player !== 'undefined') {
                  videoVars.player.unMute();
                  videoVars.player.setVolume(progress * 100);
                  updateVolumeIcon(videoVars.player.getVolume());
                } else {
                  $videoModal.find('video')[0].muted = false;
                  $videoModal.find('video')[0].volume = progress;
                  updateVolumeIcon(progress * 100);
                }

                hideVolumeSlider();
              }
            })[0];

            // Set up Youtube
            (function () {
              // DOM
              var tag = document.createElement('script');
              var firstScriptTag = document.getElementsByTagName('script')[0];

              window.onYouTubeIframeAPIReady = function () {
                // DOM
                videoVars.youtubeAPIReady = true;

                $window.trigger('youtubeready');
              };

              tag.src = 'https://www.youtube.com/iframe_api';
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            })();

            // NOTE: Mute disables a ton USE AT OWN RISK
            if (platformVars.isMobile) {
              $videoModal.find('video')[0].muted = false;
              updateVolumeIcon(0);
            }
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Open youtube modal then play youtube video via API
            $boutique.find('[data-youtube-id]:not([data-youtube-id=""]), [data-video-url-mp4]:not([data-video-url-mp4=""]), [data-video-url-webm]:not([data-video-url-webm=""])').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $videoTag = $videoModal.find('video');
              var $videoYoutube = $videoModal.find('.video');
              // LOGIC
              var videoID = $this.data('youtube-id');
              var videoURLMP4 = $this.data('video-url-mp4');
              var videoURLWEBM = $this.data('video-url-webm');
              var isVideoSet = false;

              e.preventDefault();
              e.stopPropagation();
              $window.trigger('videomodalopened');

              // Must have a youtube ID otherwise attempt to play normal video
              if (typeof videoID !== 'undefined' && videoID.trim().length !== 0) {
                $videoTag.css({ display: 'none' });
                $videoYoutube.css({ display: 'block' });

                TweenMax.fromTo($videoModal, 0.5, { opacity: 0,
display: 'none' }, { opacity: 1,
display: 'block',
className: '+=active' });

                videoVars.player = new YT.Player($videoYoutube[0], {
                  height: '360',
                  width: '640',
                  videoId: videoID,
                  playerVars: {
                    autoplay: 0, // Autoplay is handled via on ready
                    rel: 0,
                    showinfo: 1,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    controls: 0,
                    start: 1,
                    playsinline: 1,
                    enablejsapi: 1,
                    html5: 1
                  },
                  events: {
                    // Mute needed for mobile autoplay
                    onReady: function () {
                      if (!platformVars.isDesktop && platformVars.isMobile) {
                        videoVars.player.mute();
                        updateVolumeIcon(0);
                      }
                      videoVars.player.playVideo();
                    },
                    onStateChange: function (e) {
                      var state = e.data;

                      // Unstarted/Play/Buffering
                      // Reveal video
                      if (state === -1 || state === 1 || state === 3) {
                        videoVars.scrubberUpdateTimer = window.setInterval(youtubeUpdateHandler, 500);
                        $videoModal.find('.play_btn').addClass('js-active');
                        // Ended
                        // Hide video
                      } else if (state === 0) {
                        $videoModal.find('.close_btn').trigger('click');
                        $videoModal.find('.play_btn').removeClass('js-active');
                      } else {
                        $videoModal.find('.play_btn').removeClass('js-active');
                      }
                    }
                  }
                });
              } else {
                $videoTag.css({ display: 'block' });
                $videoYoutube.css({ display: 'none' });
                // Clear URLS
                $videoTag.find('source').attr('src', '');

                if (/\.(mp4){1}$/gi.test(videoURLMP4)) {
                  $videoTag.find('source[type="video/mp4"]').attr('src', videoURLMP4);
                  isVideoSet = true;
                }

                if (/\.(webm){1}$/gi.test(videoURLWEBM)) {
                  $videoTag.find('source[type="video/webm"]').attr('src', videoURLWEBM);
                  isVideoSet = true;
                }

                // Attempt to load everything
                $videoTag[0].load();

                if (isVideoSet) {
                  $videoTag.one('canplay', function () {
                    this.play();
                  });

                  TweenMax.fromTo($videoModal, 0.5, { opacity: 0,
display: 'none' }, { opacity: 1,
display: 'block',
className: '+=js-active' });
                }
              }
            })
            // Allow links out to function normally
              .find('.explore-more').on('click', function (e) {
                e.stopPropagation();
              });

            // Video play button click
            $videoModal.find('.play_btn').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $video = $videoModal.find('video');

              e.preventDefault();

              // Clear existing video update timers
              if (typeof videoVars.scrubberUpdateTimer !== 'undefined') {
                clearInterval(videoVars.scrubberUpdateTimer);
              }

              videoVars.scrubberUpdateTimer = setInterval(youtubeUpdateHandler, 500);

              if (typeof videoVars.player !== 'undefined') {
                if ($this.hasClass('js-active')) {
                  videoVars.player.pauseVideo();
                  $this.removeClass('js-active');
                } else {
                  videoVars.player.playVideo();
                  $this.addClass('js-active');
                }
              } else {
                if ($this.hasClass('js-active')) {
                  $video[0].pause();
                  $this.removeClass('js-active');
                } else {
                  $video[0].play();
                  $this.add('js-active');
                }
              }
            });

            $videoModal.find('.volume_btn').on('click', function (e) {
              // DOM
              var $this = $(this);

              e.preventDefault();

              // Mobile toggles volume
              if (platformVars.isMobile) {
                if ($volumeButton.hasClass('js-vol-0')) {
                  if (typeof videoVars.player !== 'undefined') {
                    videoVars.player.unMute();
                    videoVars.player.setVolume(100);
                  } else {
                    $videoModal.find('video')[0].muted = false;
                    $videoModal.find('video')[0].volume = 1;
                  }
                  updateVolumeIcon(100);
                } else {
                  if (typeof videoVars.player !== 'undefined') {
                    videoVars.player.mute();
                    videoVars.player.setVolume(0);
                  } else {
                    $videoModal.find('video')[0].muted = true;
                    $videoModal.find('video')[0].volume = 0;
                  }
                  updateVolumeIcon(0);
                }

                return;
              }

              if ($this.hasClass('js-active')) {
                $this.removeClass('js-active');
              } else {
                $this.addClass('js-active');

                hideVolumeSlider();
              }
            });

            // Volume slider click handling
            $videoModal.find('.volume_btn .line-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $volumeKnob = $this.find('.circle');
              // LOGIC
              var progress = ($this.offset().top - $window.scrollTop() - e.clientY) / $this.height();

              e.preventDefault();
              e.stopPropagation();

              TweenMax.set($volumeKnob, { top: volumeSlider.maxY * progress });

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.unMute();
                videoVars.player.setVolume(progress * 100);
                updateVolumeIcon(videoVars.player.getVolume());
              } else {
                $videoModal.find('video')[0].muted = false;
                $videoModal.find('video')[0].volume = progress;
                updateVolumeIcon(progress * 100);
              }

              volumeSlider.update(true);
              volumeSlider.startDrag(e);
              volumeSlider.endDrag(e);

              hideVolumeSlider();
            });

            // Video scrubber click
            $videoModal.find('.scrubber-container').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $video = $videoModal.find('video');
              // LOGIC
              var position = e.clientX - $this.offset().left;
              var duration;
              var progress = position / $this.width();

              e.preventDefault();

              $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');

              if (typeof videoVars.player !== 'undefined' && typeof videoVars.player.getDuration === 'function') {
                duration = videoVars.player.getDuration();
                videoVars.player.seekTo(duration * progress);
              } else {
                $video[0].currentTime = $video[0].duration * progress;
              }
            });

            // Video fullscreen click
            $videoModal.find('.full_btn').on('click', function (e) {
              // DOM
              var $player;
              var $video = $videoModal.find('video');
              // LOGIC
              var requestFullScreen;

              e.preventDefault();

              // Must have an available player to do stuff
              if (typeof videoVars.player !== 'undefined') {
                $player = $videoModal.find('iframe');
                if ($player.length === 0) {
                  return;
                }
                requestFullScreen = $player[0].requestFullScreen || $player[0].mozRequestFullScreen || $player[0].webkitRequestFullScreen;
                requestFullScreen.call($player[0]);
              } else {
                requestFullScreen = $video[0].requestFullScreen || $video[0].mozRequestFullScreen || $video[0].webkitRequestFullScreen;
                requestFullScreen.call($video[0]);
              }
            });

            // Video close button click
            $videoModal.find('.close_btn').on('click', function (e) {
              // DOM
              var $video = $videoModal.find('video');

              e.preventDefault();
              e.stopPropagation();

              // Clear existing video update timers
              if (videoVars.scrubberUpdateTimer !== 'undefined') {
                window.clearInterval(videoVars.scrubberUpdateTimer);
              }

              if (typeof videoVars.player !== 'undefined') {
                videoVars.player.destroy();
                videoVars.player = undefined;
              } else {
                $video[0].pause();
                $video[0].currentTime = 0;
              }

              TweenMax.to($videoModal, 0.5, { opacity: 0,
display: 'none',
className: '-=active' });

              $window.trigger('videomodalclosed');
            });

            $videoModal.find('video')
              .on('timeupdate', function () {
                var duration;
                var currentTime;
                var progress;

                duration = this.duration;
                currentTime = this.currentTime;
                progress = currentTime / duration;

                $videoModal.find('.inner_scrubber').css('width', (progress * 100) + '%');
              })
              .on('ended', function () {
                $videoModal.find('.close_btn').trigger('click');

                if (platformVars.isMobile) {
                  if (typeof this.webkitExitFullScreen === 'function') {
                    this.webkitExitFullScreen();
                  }
                }
              })
              .on('play playing', function () {
                $videoModal.find('.play_btn').addClass('js-active');
              })
              .on('pause', function () {
                $videoModal.find('.play_btn').removeClass('js-active');
              });
          }
          // END: Events
        })();
        // END: Video Model Handling

        // BEGIN: Inline Video Handling
        (function () {
          // DOM
          var $inlineVideo = $('.mp4-container video');

          // BEGIN: Events
          events: {
            $window
              .on('videomodalopened', function () {
                // Pause all inline videos
                $inlineVideo.each(function () {
                  this.pause();
                });
              })
              .on('videomodalclosed generic-preload-complete', function () {
                // Pause all inline videos
                $inlineVideo.each(function () {
                  this.play();
                });

                $boutique.addClass('loaded');
              });
          }
          // END: Events
        })();
        // ////////////////////////////////////////////////////////////////////////////////////
        // //////////// END: Inline Video Handling
        // ////////////////////////////////////////////////////////////////////////////////////

        // BEGIN: Scroll Handling
        // Functionality should only happen once preload completes
        $window.on('holiday-preload-complete', function () {
          // Marks active sections
          $window.on('scroll', function () {
            // DOM
            var $targets = $sections.not(':hidden');
            var $activeSections;
            // LOGIC
            var id;

            // Mobile  tracks additional elements
            if (platformVars.isMobile) {
              // Include Holiday footer
              $targets = $sections.not(':hidden, #section_gifts');
              $targets = $targets.add('#section-footer').not(':hidden');
              $targets = $targets.add($sections.not('#section_gifts').find('.tile-description')); // Special case for mobile
              $targets = $targets.add($('#section_gifts .slide')).not(':hidden');
            }

            // Set active elements
            elementScrollProgress($targets.toArray(), {
              activeClass: 'js-active',
              visibleClass: 'js-visible',
              eventGainVisible: 'gainedVisible',
              eventGainCurrent: 'gainedActive'
            });

            // Set deeplink hash
            $activeSections = $sections.filter('.js-active');

            if ($activeSections.length !== 0) {
              id = $activeSections.first().attr('id');

              if (typeof id !== 'undefined') {
                hashHelper.set(id.replace('section_', ''));
              }
            }
          });

          $window.trigger('scroll');
        });
        // END: Scroll Handling

        // BEGIN: Carousel Handling
        // NOTE: Animations should be handled through slideHasGainedActive
        // $window.on('holiday-preload-complete', function() {
        (function () {
          // DOM
          // Ignore carousels within custom MPP
          var $carouselContainers = $boutique.find('.carousel_container').filter(function () {
            return $(this).closest('.custom-mpp').length !== 1;
          });
          // LOGIC
          var carouselTarget = '.carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : '');
          var carouselSettings = {
            increment: '100%',
            offset: '0%',
            ignoreTargets: '.ignore',
            debug: false,
            useGSAP: false,
            duration: 1,
            callbackAnimation: function () {
              // DOM
              var $newSlide;
              var $otherSlides;
              // LOGIC
              var _this = this;
              var animation = new TimelineMax();

              $newSlide = _this.slides[0];
              $otherSlides = $newSlide.siblings();

              $newSlide.trigger('slideWillGainActive');
              $otherSlides.trigger('slideWillLoseActive'); // Signal that the last slide will lose active after animation

              animation
                .to($otherSlides, 0.5, {
opacity: 0,
display: 'none',
position: 'absolute',
className: '-=active'
})
                .to($newSlide, 0.5, {
opacity: 1,
display: 'block',
position: 'relative',
className: '+=active'
}, '0')
                .add(function () {
                  $newSlide.trigger('slideHasGainedActive');
                  _this.$target.trigger('carousel_updated', $newSlide.index());
                });
            }
          };

          // Get the Look variations handle carousel functionality itself
          if ($boutique.hasClass('get-the-look')) {
            return;
          }

          // BEGIN: Init
          init: {
            $carouselContainers.each(function () {
              // DOM
              var $this = $(this);
              var $carousel = $this.find(carouselTarget);
              var $carouselDotContainer = $this.find('.carousel_pagination ul');

              carouselSettings.$dot_container = $carouselDotContainer;
              carouselSettings.$dot_template = $carouselDotContainer.find('.template');

              if ($carousel.children().length > 1 && !platformVars.isMobile) {
                $carousel.elCarousel(carouselSettings);
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'block' });

              // Otherwise hide controls and make "first" slide the active slide
              } else {
                $carousel.children().first().addClass('js-active');
                $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
              }

              // Hide pagination for mobile only
              if (platformVars.isMobile) {
                $this.find('.carousel_pagination').css({ display: 'none' });
              }
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Global stopper for blank a tags in carousels
            $carouselContainers.find('a[href=""]').on('click', function (e) {
              e.preventDefault();
            });

            // Carousel progression via arrow click
            $carouselContainers.find('.carousel_pagers li, .arrow').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container').find(carouselTarget);

              e.preventDefault();

              if ($this.hasClass('previous') || $this.hasClass('left')) {
                $carousel.elCarouselPrev();
              } else if ($this.hasClass('next') || $this.hasClass('right')) {
                $carousel.elCarouselNext();
              }
            });

            // Carousel navigation via dot nav click
            $carouselContainers.find('.carousel_pagination ul li').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $carousel = $this.closest('.carousel_container').find(carouselTarget);
              // LOGIC
              var index = $this.index() - 1;

              e.preventDefault();

              $this.addClass('js-active').siblings().removeClass('js-active');

              $carousel.elCarouselTo(index);
            });

            // Dot nav update on carousel update
            $carouselContainers.on('carousel_updated', function (e, index) {
              $(this).find('.carousel_pagination ul li').eq(index + 1).addClass('js-active').siblings().removeClass('js-active');
            });

            // Carousel progression via swipe
            $carouselContainers.find(carouselTarget).swipe({
              swipeLeft: function () {
                $(this).elCarouselNext();
              },
              swipeRight: function () {
                $(this).elCarouselPrev();
              },
              excludedElements: 'button, input, select, textarea, .noSwipe',
              preventDefaultEvents: false
            });

            // Carousel progression via keyboard directional key press
            $window
              .on('keydown', function (e) {
                // Find carousels in active sections
                $carouselContainers.each(function () {
                  // DOM
                  var $this = $(this);
                  var $carousel = $this.find(carouselTarget);

                  // Container section must be active
                  if ($this.closest('section.active').length === 0) {
                    return;
                  }

                  switch (e.which) {
                    // Previous
                    case 37:
                      $carousel.elCarouselPrev();
                      break;

                      // Next
                    case 39:
                      $carousel.elCarouselNext();
                      break;
                  }
                });
              })
            // Destroy carousel in mobile mode
              .on('desktopGainedMobile', function () {
                $carouselContainers.find(carouselTarget).elCarouselDestroy().children().removeAttr('style');
                $carouselContainers.find(carouselTarget).children().first().addClass('js-active').siblings().removeClass('js-active');
                $carouselContainers.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
              })
            // Rebuild carousel
              .on('desktopLostMobile', function () {
                $carouselContainers.each(function () {
                  // DOM
                  var $this = $(this);
                  var $carousel = $this.find(carouselTarget);
                  var $carouselDotContainer = $this.find('.carousel_pagination ul');

                  carouselSettings.$dot_container = $carouselDotContainer;
                  carouselSettings.$dot_template = $carouselDotContainer.find('.template');

                  // Enable carousel for desktop
                  if ($carousel.children().length > 1) {
                    $carousel.elCarousel(carouselSettings);
                    $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'block' });
                  } else {
                    // Carousel children needs active to be visible
                    $carousel.children().first().addClass('js-active').siblings().removeClass('js-active');
                    $this.find('.carousel_pagers, .carousel_pagination').css({ display: 'none' });
                  }

                  // Carousel children needs active to be rendered
                  $carousel.children().first().addClass('js-active');
                });
              });
          }
          // END: Events
        })();
        // });
        // END: Carousel Handling
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // //////////// END: Global Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Holiday - Section Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $mouseSparkle = $boutique.find('.mouse-sparkle'); // Target image to clone for drawing
        // LOGIC
        var particleSettings = {
          FPS: 30,
          particles: {},
          updateInterval: undefined,
          renderInterval: undefined, // Fallback for IE 9
          shouldRender: true
        };
        var ribbons = [
          // LANDING RIBBONS
          {
            $parent: $('#section_landing'),
            $element: $('#section_landing .ribbon').eq(0),
            backgroundPosition: '0% 0%',
            width: 187,
            height: 369,
            duration: 1,
            timeOffset: '0.5',
            path: [
              { height: 13,
width: 0 },
              { height: 13,
width: 18 },
              { height: 55.5,
width: 18 }
            ]
          },
          {
            $parent: $('#section_landing'),
            $element: $('#section_landing .ribbon').eq(1),
            backgroundPosition: '0% 0%',
            width: 351,
            height: 237,
            duration: 1,
            timeOffset: '-=0.7',
            path: [
              { height: 0,
width: 6.7 },
              { height: 21,
width: 6.7 },
              { height: 21,
width: 33.85 },
              { height: 35.5,
width: 33.85 }
            ]
          },
          {
            $parent: $('#section_landing'),
            $element: $('#section_landing .ribbon').eq(2),
            backgroundPosition: '0% 0%',
            width: 351,
            height: 237,
            duration: 1,
            timeOffset: '+=0',
            path: [
              { height: 0,
width: 10.8 },
              { height: 28.2,
width: 10.8 },
              { height: 28.2,
width: 54.85 }
            ]
          },
          // PARTY READY LOOKS RIBBONS
          {
            $parent: $('#section_party-ready-looks'),
            $element: $('#section_party-ready-looks .ribbon').eq(0),
            backgroundPosition: '100% 100%',
            width: 199,
            height: 96,
            duration: 0.8,
            timeOffset: '-=1',
            path: [
              { height: 0,
width: 7 },
              { height: 14,
width: 7 },
              { height: 14,
width: 19 }
            ]
          },
          {
            $parent: $('#section_party-ready-looks'),
            $element: $('#section_party-ready-looks .ribbon').eq(1),
            backgroundPosition: '100% 100%',
            width: 115,
            height: 83,
            duration: 0.8,
            timeOffset: '0',
            path: [
              { height: 0,
width: 11.8 },
              { height: 14.15,
width: 11.8 },
              { height: 14.15,
width: 32 }
            ]
          },
          // ESTEE STORIES RIBBONS
          {
            $parent: $('#section_estee-stories'),
            $element: $('#section_estee-stories .ribbon').eq(0),
            backgroundPosition: '0% 0%',
            width: 189,
            height: 395,
            duration: 1,
            timeOffset: '-=0.7',
            path: [
              { width: 0,
height: 19.15 },
              { width: 26,
height: 19.15 },
              { width: 26,
height: 19.15 },
              { width: 26,
height: 88.15 }
            ]
          },
          {
            $parent: $('#section_estee-stories'),
            $element: $('#section_estee-stories .ribbon').eq(1),
            backgroundPosition: '100% 0%',
            width: 122,
            height: 241,
            duration: 1,
            timeOffset: '-=0.2',
            path: [
              { width: 0,
height: 30 },
              { width: 18.75,
height: 30 },
              { width: 18.75,
height: 56 }
            ]
          }
        ];

        /**
        * @function ribbonData
        * @description Scales the ribbon image to it's natural width
        * @param {object} ribbonData Stuff
        * @returns {undefined}
        */
        function scaleRibbon(ribbonData) {
          // Scale ribbon actual to their containers
          var scale = ribbonData.container.width / ribbonData.width;

          ribbonData.$element.css({ backgroundSize: (ribbonData.width * scale) + 'px ' + (ribbonData.height * scale) + 'px' });

          return scale;
        }

        /**
        * @function generateRibbonAnimation
        * @description returns a TimelineMax object that represents the animation described by ribbonData
        * @param {object} ribbonData Stuff
        * @param {jQuery} ribbonData.$element Element to affect
        * @param {duration} ribbonData.duration Duration of element
        * @param {number} ribbonData.width Original width of image element
        * @param {number} ribbonData.height Original height of image element
        * @param {array} ribbonData.path Series of objects representing ribbon growth
        * @returns {TimelineMax} The ribbon growth animation
        */
        function generateRibbonAnimation(ribbonData) {
          var ribbonAnimation = new TimelineMax();
          var distance = 0;
          var distanceTotal = 0;

          // Iterate through path and build distances
          ribbonData.path.forEach(function (ribbonPath, index) {
            if (index === 0) {
              return;
            }
            distance = Math.sqrt((ribbonPath.width - ribbonData.path[index - 1].width)**2 + (ribbonPath.height - ribbonData.path[index - 1].height)**2);

            distanceTotal += distance;
            ribbonPath.distance = distance;
          });

          ribbonData.path.forEach(function (ribbonPath, index) {
            if (index === 0) {
              ribbonAnimation.set(ribbonData.$element, ribbonPath);
            } else if (index + 1 >= ribbonData.path.length) {
              ribbonAnimation.to(ribbonData.$element, ribbonData.duration * ribbonPath.distance / distanceTotal, {
width: ribbonPath.width + '%',
height: ribbonPath.height + '%',
ease: Power4.easeOut,
clearProps: 'width, height'
});
            } else {
              ribbonAnimation.to(ribbonData.$element, ribbonData.duration * ribbonPath.distance / distanceTotal, { width: ribbonPath.width + '%',
height: ribbonPath.height + '%',
ease: Power0.easeNone });
            }
          });

          return ribbonAnimation;
        }

        /**
        * @function createTextAnimation
        * @description Creates letter by letter fade in from left given an element that contains a span
        * @param {jQuery} $element Element to process for text animation, text inside will be split into individual letters wrapped by a span
        * @returns {TimelineMax} The text animation
        */
        function createTextAnimation($element) {
          // LOGIC
          var words = $element.html().split(' ');
          var newHTML = '';
          var newWord = '';
          var textAnimation = new TimelineMax();

          words.forEach(function (word) {
            word.split('').forEach(function (letter) {
              newWord += '<span>' + letter + '</span>';
            });

            newHTML += newHTML.length === 0 ? newWord : ' ' + newWord;
            newWord = '';

            $element.html(newHTML);
          });
          textAnimation.from($element, 1, { x: '-10%' });
          textAnimation.staggerFromTo($element.children('span'), 0.3, { opacity: 0 }, { opacity: 1 }, 0.1, '0');

          return textAnimation;
        }

        /**
        * @function spawnParticle
        * @description Spawns particles for a given canvas
        * @param {jQuery} $canvas to spawn particles in
        * @param {number} x X position to spawn particles
        * @param {number} y Y position to spawn particles
        * @param {number} particlesToSpawn Number of particles to spawn
        * @returns {undefined}
        */
        function spawnParticle($canvas, x, y, particlesToSpawn) {
          // LOGIC
          var rotation;
          var anglePosition;
          var baseLifetime = 3000;
          var lifetimeVariance = 1000;
          var lifetime = baseLifetime - (lifetimeVariance * Math.random());
          var startDistance = 10 * Math.random();
          var p = 0;

          if ($canvas.length === 0) {
            return;
          }

          for (p = 0; p < particlesToSpawn; p++) {
            rotation = 360 * Math.random(); // Starting rotation
            anglePosition = 360 * Math.random() * Math.PI / 180;
            particleSettings.particles['p' + Date.now() + p] = {
              canvas: $canvas,
              image: $mouseSparkle[0],
              velocity: { x: 2 * Math.cos(rotation * Math.PI / 180),
y: 2 * Math.sin(rotation * Math.PI / 180) },
              position: { x: x + startDistance * Math.cos(anglePosition),
y: y + startDistance * Math.sin(anglePosition) },
              rotation: rotation,
              rotationDir: Math.random() >= 0.5 ? 1 : -1,
              endTime: Date.now() + lifetime,
              scale: 1 - 0.8 * Math.random(),
              opacity: 1 - 0.4 * Math.random(),
              lifetime: lifetime
            };
          }
        }

        /**
        * @function particleUpdate
        * @description Logic that updates each particle
        * @returns {undefined}
        */
        function particleUpdate() {
          var particle;
          var currentTime = Date.now();
          var progress;

          Object.keys(particleSettings.particles).forEach(function (key) {
            particle = particleSettings.particles[key];
            progress = (Math.floor(particle.endTime) - currentTime) / particle.lifetime;
            progress = progress <= 0 ? 0 : progress >= 1 ? 1 : progress;

            if (currentTime >= Math.floor(particle.endTime)) {
              delete particleSettings.particles[key];

              return;
            }

            // Lower scale
            particle.scale *= progress;
            particle.scale = particle.scale < 0.01 ? 0 : particle.scale;

            // Update position
            particle.position.x += particle.velocity.x;
            particle.position.y += particle.velocity.y;

            // Update rotation
            particle.rotation += particle.rotationDir;

            // Lower velocity
            particle.velocity.x -= particle.velocity.x * 0.05;
            particle.velocity.y -= particle.velocity.y * 0.05;
          });
        }

        /**
        * @function particleRender
        * @description Renders each particle on canvas
        * @returns {undefined}
        */
        function particleRender() {
          // DOM
          var $canvas;
          var image;
          // LOGIC
          var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
          var particle;
          var context;
          var position;
          var currentTime = Date.now();
          var progress;

          if (!particleSettings.shouldRender) {
            return;
          }

          // Clear each canvas
          $boutique.find('canvas').each(function () {
            // DOM
            var $this = $(this);
            // LOGIC
            var context = $this.data('context');

            if (typeof context === 'undefined') {
              return;
            }

            context.clearRect(0, 0, context.canvas.width, context.canvas.height);
          });

          // Draw each particle
          Object.keys(particleSettings.particles).forEach(function (key) {
            particle = particleSettings.particles[key];
            $canvas = particle.canvas;
            context = $canvas.data('context');
            image = particle.image;
            position = particle.position;
            progress = (particle.endTime - currentTime) / particle.lifetime;
            progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;

            if (typeof context === 'undefined') {
              return;
            }

            context.globalAlpha = particle.opacity * progress;
            context.translate(position.x, position.y);
            context.scale(particle.scale, particle.scale);
            context.rotate(particle.rotation * Math.PI / 180);
            context.drawImage(image, -image.width / 2, -image.height / 2);
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.globalAlpha = 1;
          });
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(particleRender);
          }
        }

        /**
        * @function startParticleUpdate
        * @description Starts render and logic loops for particles
        * @returns {undefined}
        */
        function startParticleUpdate() {
          var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

          particleSettings.updateInterval = window.setInterval(particleUpdate, 1000 / particleSettings.FPS);

          particleSettings.shouldRender = true;

          // Use request animation frame if available, otherwise fallback to interval
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(particleRender);
          } else {
            particleSettings.renderInterval(particleRender(), 1000 / particleSettings.FPS);
          }
        }

        /**
        * @function startParticleUpdate
        * @description Stops render and logic loops for particles
        * @returns {undefined}
        */
        function stopParticleUpdate() {
          if (typeof particleUpdateInterval !== 'undefined') {
            window.clearInterval(particleSettings.updateInterval);
            particleSettings.updateInterval = undefined;
          }

          if (typeof particleRenderInterval !== 'undefined') {
            window.clearInterval(particleSettings.renderInterval);
            particleSettings.renderInterval = undefined;
          }

          particleSettings.shouldRender = false;
        }

        var mouseMoveHandler = (function () {
          var particleSpawnTimeout;

          return function ($canvas, x, y) {
            if (typeof particleSpawnTimeout !== 'undefined') {
              return;
            }

            if ($canvas.length !== 0) {
              spawnParticle($canvas, x, y, 2);
            }

            particleSpawnTimeout = setTimeout(function () {
              particleSpawnTimeout = undefined;
            }, 50);
          };
        })();

        // Functionality should only exist on landing page
        if (!$boutique.hasClass('landing')) {
          return;
        }

        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section - Shared
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          // BEGIN: Init
          init: {
            // Build intro animations for each section
            $sections.each(function () {
              // DOM
              var $this = $(this);
              var $mainContent = $this.find('.tile-description').not(function () {
                var $this = $(this);

                if ($this.closest('.slide').length !== 0 && !$this.closest('.slide').is(':first-child')) {
                  return true;
                }

                return false;
              });
              var $sectionText = $this.find('.tile-description span');
              // LOGIC
              var introAnimation = new TimelineMax({ paused: true });
              var textAnimation = new TimelineMax({ paused: true,
delay: 0.25 });

              // #section_gifts does not have normal intro animations on mobile
              if ($this.is('#section_gifts')) {
                return;
              }

              // Only the landing section doesn't animate background
              if (!$this.is('#section_landing')) {
                $mainContent = $mainContent.add($this.find('.image-container'));
              }

              introAnimation
                .fromTo($mainContent, 1, { opacity: 0 }, { opacity: 1 });

              // Split text into individual spans and create text animation
              $sectionText.each(function () {
                var $parent = $(this).parent();

                if ((platformVars.isMobile && $parent.hasClass('mobile')) || (!platformVars.isMobile && !$parent.hasClass('mobile'))) {
                  ($this.is('#section_party-ready-looks') && !platformVars.isMobile ? introAnimation : textAnimation).add(createTextAnimation($(this)), textAnimation.totalDuration() === 0 && !platformVars.isMobile ? '0' : '-=0.7');
                }
              });

              // On mobile, we target the actual text container, as due to design, the user might not see the entire section as they scroll
              (platformVars.isMobile ? $this.find('.tile-description') : $this).data('textAnimation', textAnimation);

              // Generate ribbon animations
              ribbons.forEach(function (element) {
                if ($this.is(element.$parent)) {
                  // Record original sizes of containers
                  element.container = { width: element.$element.width(),
height: element.$element.height() };

                  // Scale ribbons to fit their container sizes
                  scaleRibbon(element);
                  element.$element.css({ backgroundPosition: element.backgroundPosition });
                  if ((platformVars.isMobile && element.$element.hasClass('mobile')) || (!platformVars.isMobile && !element.$element.hasClass('mobile'))) {
                    introAnimation.add(generateRibbonAnimation(element), element.timeOffset);
                  }
                }
              });

              $this.data('introAnimation', introAnimation);
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Prevent any init based on resize from triggering the resize handling defined below
            $window.one('initResize', function () {
              var oldWindowWidth = $window.width();

              // On resize: Complete all intro animations and scale ribbons
              $window.on('resize', _.debounce(function () {
                // Do not run if window width is still the same
                if ($window.width() === oldWindowWidth) {
                  return;
                }

                $sections.each(function () {
                  var animation = $(this).data('introAnimation');

                  if (typeof animation !== 'undefined') {
                    animation.progress(1);
                  }
                });

                ribbons.forEach(function (element) {
                  element.container.width = element.$element.width();
                  element.container.height = element.$element.height();
                  scaleRibbon(element);
                });

                oldWindowWidth = $window.width();
              }, 100));
            });

            $sections.find('.tile-description').one('gainedVisible', function () {
              var animation = $(this).data('textAnimation');

              if (typeof animation !== 'undefined') {
                animation.play();
              }
            });

            $sections
              .one('gainedVisible', function () {
                var animation = $(this).data('introAnimation');

                if (typeof animation !== 'undefined') {
                  animation.play();
                }

                $window.trigger('initResize');
              })
              .one('gainedActive', function () {
                var animation = $(this).data('textAnimation');

                if (typeof animation !== 'undefined') {
                  animation.play();
                }
              })
              .on('mousemove', function (e) {
              // DOM
                var $canvas = $(this).find('canvas');

                // Particle functionality should not work in touch environments and older IE versions
                if ($(this).is('#section_gifts') || platformVars.isMobile || platformVars.isIpad || (platformVars.isIE && (platformVars.isIE !== -1 && platformVars.isIE <= 9))) {
                  return;
                }

                if ($canvas.length !== 0) {
                  mouseMoveHandler($canvas, e.pageX - $canvas.offset().left, e.pageY - $canvas.offset().top);
                }
              });

            // Specific functionality for the carousel section
            $('#section_gifts .slide').on('mousemove', function (e) {
              // DOM
              var $canvas = $(this).find('canvas');

              // Particle functionality should not work in touch environments and older IE versions
              if (platformVars.isMobile || platformVars.isIpad || (platformVars.isIE && (platformVars.isIE !== -1 && platformVars.isIE <= 9))) {
                return;
              }

              // Canvas positions are not one to one with screen position, potentially due to slides positioned by transform
              if ($canvas.length !== 0) {
                mouseMoveHandler($canvas, e.pageX - $('#section_gifts').offset().left, e.pageY - $('#section_gifts').offset().top);
              }
            });

            // Update canvases
            $window
              .on('resize canvasUpdate', function () {
                // DOM
                var $canvas = $boutique.find('canvas');

                $canvas.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var context = $this.data('context');

                  if (typeof context === 'undefined') {
                    return;
                  }

                  context.canvas.width = $this.width();
                  context.canvas.height = $this.height();
                });
              })
              .on('holiday-preload-complete', function () {
                // DOM
                var $canvas = $boutique.find('canvas');

                // Canvas
                if (platformVars.isMobile || platformVars.isIpad || (platformVars.isIE && (platformVars.isIE !== -1 && platformVars.isIE <= 9))) {
                  return;
                }

                // Initialize each canvas
                $canvas.each(function () {
                  // LOGIC
                  var context;

                  context = this.getContext('2d');
                  context.canvas.width = $(this).width();
                  context.canvas.height = $(this).height();

                  $(this).data('context', context);
                });

                startParticleUpdate();
              })
              .on('blur', function () {
                stopParticleUpdate();
              })
              .on('focus', function () {
                startParticleUpdate();
              });
          }
          // END: Events
        })();
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section - Shared
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////

        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 1
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          // DOM
          var $self = $('#section_landing');
          // LOGIC
          var parallaxAnimation = new TimelineMax({ paused: true });

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            parallaxAnimation.to($self.find('.background.desktop'), 1, { y: '-=10%' });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Handle parallaxing
            $window.on('scroll', function () {
              // LOGIC
              var progress = 1;
              var sectionHeight = $self.outerHeight();
              var scrollTop = $window.scrollTop();
              var offsetTop = $self.offset().top;
              var currentPos = scrollTop - offsetTop;

              currentPos = currentPos <= 0 ? 0 : currentPos;

              progress = Math.abs(currentPos / (sectionHeight + offsetTop));
              progress = progress >= 1 ? 1 : progress <= 0 ? 0 : progress;

              parallaxAnimation.progress(progress);
            });
          }
          // END: Events
        })();
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 1
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////

        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 3
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          // DOM
          var $self = $('#section_gifts');
          var $carousel = $self.find('.carousel_container .carousel' + ($body.hasClass('device-pc') || $body.hasClass('device-mobile') ? ' .content' : ''));
          var $carouselSlides = $carousel.find('.slide');

          if ($self.length === 0) {
            return;
          }

          // BEGIN: Init
          init: {
            // Create animation per slide
            $carouselSlides.each(function (index) {
              // DOM
              var $this = $(this);
              var $text = $this.find('.tile-description').children().find('> span');
              // LOGIC
              var animation = new TimelineMax({ paused: true,
delay: 0.25 });
              var textAnimation = new TimelineMax({ paused: true,
delay: 0.25 });
              var textAnimationDestination = index === 0 || platformVars.isMobile ? textAnimation : animation; // On desktop, textAnimation is exlusive to the first slide. Mobile, text animation is for all
              var ribbons = [
                {
                  $element: $this.find('.ribbon').eq(0),
                  backgroundPosition: '0% 0%',
                  container: {
                    width: $this.find('.ribbon').width(),
                    height: $this.find('.ribbon').height()
                  },
                  width: 88,
                  height: 240,
                  duration: 1,
                  timeOffset: '+=0',
                  path: [
                    { width: 0,
height: 11 },
                    { width: 13.8,
height: 11 },
                    { width: 13.8,
height: 31.5 }
                  ]
                }
              ];

              if (platformVars.isDesktop && $this.hasClass('first') || platformVars.isMobile) {
                animation.fromTo($this.find('.image-container'), 1, { opacity: 0 }, { opacity: 1 });
              }

              $text.each(function (index) {
                textAnimationDestination.add(createTextAnimation($(this)), index === 0 ? '0' : '-=0.7');
              });

              if (index === 0 || platformVars.isMobile) {
                $this.data('textAnimation', textAnimation);
              }

              // So far only mobile has ribbons in this section
              if (platformVars.isMobile) {
                ribbons.forEach(function (element) {
                  scaleRibbon(element);

                  element.$element.css({ backgroundPosition: element.backgroundPosition });

                  animation.add(generateRibbonAnimation(element), element.timeOffset);
                });
              }

              animation
                .addCallback(function () {
                  $this.removeData('animation');
                })
                .addPause();

              $this.data('animation', animation);
            });
          }
          // END: Init

          // BEGIN: Events
          events: {
            // Should be desktop only event handling for this section gaining an active state
            $self
              .one('gainedActive', function () {
                $carouselSlides.first().trigger('gainedActive');
              })
              .one('gainedVisible', function () {
                $carouselSlides.first().trigger('gainedVisible');
                $carouselSlides.one('slideHasGainedActive', function () {
                // DOM
                  var $this = $(this);
                  var $canvas = $this.find('canvas');
                  // LOGIC
                  var animation = $this.data('animation');
                  var context = $canvas.data('context');

                  if (typeof animation === 'undefined') {
                    return;
                  }

                  // Update context dimensions, normal initialization has canvases hidden
                  if (typeof context !== 'undefined') {
                    context.canvas.width = $canvas.width();
                    context.canvas.height = $canvas.height();
                  }

                  animation.play(0);
                });
              });

            // Play slide animation if available
            // Mobile handling
            $carouselSlides
              .one('gainedVisible', function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var textAnimation = $this.data('textAnimation');
                var introAnimation = $this.data('animation');

                if (typeof textAnimation !== 'undefined') {
                  textAnimation.play(0);
                }

                if (typeof introAnimation !== 'undefined') {
                  introAnimation.play(0);
                }
              });

            $self.on('deeplink', function (e, data) {
              if (data.deeplinkData.length > 1) {
                $carousel.elCarouselTo(parseInt(data.deeplinkData[1]));
              }
            });
          }
          // END: Events
        })();
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 3
        // //////////////////////////////////////////////////////////////////////////////////////////////////////////
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Holiday - Section Functionality
      // ////////////////////////////////////////////////////////////////////////////////////

      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  BEGIN: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
      (function () {
        // DOM
        var $loader = $('#loader');
        var $deeplinkSection;
        var $targetImages;
        // LOGIC
        var deeplinkData = hashHelper.get();
        var spinnerOptions = {
          lines: 17, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 26, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#ffffff', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1, // Rounds per second
          trail: 30, // Afterglow percentage
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);

        // Default to first section in page
        if (deeplinkData.length === 0) {
          $deeplinkSection = $boutique.find('section').first();
        } else {
          // Attempt to find section without '#section-'
          $deeplinkSection = $boutique.find('#' + deeplinkData[0]);

          if ($deeplinkSection.length === 0) {
            // Attempt to find section with '#section-'
            $deeplinkSection = $boutique.find('#section-' + deeplinkData[0]);

            // Default to first section
            if ($deeplinkSection.length === 0) {
              $deeplinkSection = $boutique.find('section').first();
            }
          }
        }

        // Get all images before the target section images as well, as content may be sized to loaded images
        $targetImages = $deeplinkSection.add($deeplinkSection.prevAll()).find('img');
        $targetImages.FreeLoader({
          callback: function () {
            // LOGIC
            var animation = new TimelineMax({ delay: 1 });

            // Mark boutique as loaded
            $boutique.addClass('js-loaded');

            //  Load other (boutique) images normally
            $boutique.find('img').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var imageLink = $this.attr('data-src');

              if (typeof imageLink === 'string' && imageLink.trim().length !== 0) {
                $this.attr('src', imageLink);
              }
            });

            spinner.stop();

            animation
              .to($loader, 1, {
opacity: 0,
display: 'none',
onComplete: function () {
                $window.trigger('holiday-preload-complete');

                if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                  $deeplinkSection.trigger('deeplink', { deeplinkData: deeplinkData });
                }

                $window.trigger('scroll');
                $window.trigger('loadAnimationComplete');
                $window.trigger('postLoad');
              }
});

            // MPP has no deeplink
            if (!$boutique.hasClass('mpp')) {
              animation.addCallback(function () {
                var scrollValue = 0;

                // Get target scroll value if a deep link section exists
                if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
                  // Get Deeplink scroll amount
                  // If the section content is larger than window, scroll to top
                  if ($deeplinkSection.height() > $window.height() || platformVars.isMobile) {
                    scrollValue = $deeplinkSection.offset().top - $('header').height() - (platformVars.isMobile ? $('#holiday_nav').height() : 0);

                  // Otherwise scroll so that the section content is in the middle of the page
                  } else {
                    scrollValue = $deeplinkSection.offset().top - ($window.height() - $deeplinkSection.height()) / 2 - $('header').height();
                  }

                  if ($deeplinkSection.is($boutique.find('section').first())) {
                    scrollValue = 0;
                  }
                }

                if (scrollValue !== 0) {
                  TweenMax.to($window, 1, {
scrollTo: { y: scrollValue,
autoKill: false },
onComplete: function () {
                    $window.trigger('scroll');
                    $window.trigger('loadAnimationComplete');
                    $window.trigger('postLoad');
                  }
});
                }
              });
            }
          }
        });
      })();
      // ////////////////////////////////////////////////////////////////////////////////////
      // ////////////  END: Preload Functionality
      // ////////////////////////////////////////////////////////////////////////////////////
    }
  };
})(jQuery);
